'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

define(['utils/browser', 'version', 'utils/ajax'], function (Browser, Version) {

    var model;
    var meta = {};
    var config;
    var headTag = document.getElementsByTagName('script')[0].parentNode;
    var scriptTag;
    var apiHost = __LOG_API__;
    var playInterval = 0;
    var startPosition = 0;
    var playEventTriggered = false;
    var sessionTime = new Date().getTime() + '';
    var onlineCountInterval;
    var playerStoped = false;

    function getTime(showMilliseconds) {
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var date = d.getDate();
        var hour = d.getHours();
        var minutes = d.getMinutes();
        var seconds = d.getSeconds();
        var milliseconds = d.getMilliseconds();

        month = month < 10 ? '0' + month : month;
        date = date < 10 ? '0' + date : date;
        hour = hour < 10 ? '0' + hour : hour;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;

        var s = year + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds;

        if (showMilliseconds) {
            s = s + '.' + milliseconds;
        }

        return s;
    }

    function getEnv() {
        return {
            // ua: navigator.userAgent, // 由服务器端获取
            flashVersion: Browser.flashVersion(),
            cyberPlayerVersion: Version,
            ak: config.ak || '',
            provider: model.get('provider') ? model.get('provider').name : '',
            config: ''
        };
    }

    function args2search(args) {
        var s = [];

        for (var i in args) {
            if (_typeof(args[i]) === 'object') {
                s.push(i + '=' + encodeURIComponent(JSON.stringify(args[i])));
            } else {
                s.push(i + '=' + args[i]);
            }
        }

        return s.join('&');
    }

    function send(args) {
        // 停止之后，任何请求都不发
        if (playerStoped) {
            return;
        }

        var action = args.action;

        delete args.action;
        args.sendTime = getTime();
        args = args2search(args);

        if (scriptTag) {
            headTag.removeChild(scriptTag);
        }
        scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'text/javascript');

        scriptTag.src = apiHost + action + '?' + args;

        headTag.insertBefore(scriptTag, headTag.getElementsByTagName('script')[0]);
    }

    var Log = function Log(_api, _model) {
        model = _model;
        config = model.getConfiguration();
        if (__DEBUG__ || config.withLog === false) {
            return false;
        }
        var args = {};
        var mediaPlayDuration = 0;
        var waitMediaPlayInterval;

        _api.on('meta', function (e) {
            // console.log('onMeta');
            // console.log(e.metadata);
            for (var i in e.metadata) {
                meta[i] = e.metadata[i];
            }
            // console.log(meta);

            if (meta.cdn_ip) {
                args = {
                    action: '/user/web/cdn',
                    url: model.get('file') || model.getCurrentItem().file,
                    cdn: meta.cdn_ip
                };
                send(args);
            }
        });

        _api.on('beforePlay', function () {
            // console.log('onBeforePlay');
            // console.log(e);
            playerStoped = false;
            playEventTriggered = false;
            waitMediaPlayInterval = setInterval(function () {
                mediaPlayDuration += 100;
                // console.log(mediaPlayDuration);
            }, 100);
        });

        _api.on('play', function () {
            if (playEventTriggered) {
                clearInterval(waitMediaPlayInterval);
                waitMediaPlayInterval = null;
                return;
            }

            if (waitMediaPlayInterval) {
                args = {
                    action: '/media/web/available',
                    videoUrl: model.get('file') || model.getCurrentItem().file,
                    type: 'play',
                    duration: mediaPlayDuration,
                    time: getTime(true),
                    sessionTime: sessionTime,
                    env: getEnv()
                };
                send(args);

                clearInterval(waitMediaPlayInterval);
                waitMediaPlayInterval = null;
            }

            // console.log('onPlay');
            // console.log(e);

            startPosition = model.get('position');
            // console.log('startPosition: ' + startPosition);

            args = {
                action: '/user/web/play',
                videoUrl: model.get('file') || model.getCurrentItem().file,
                videoHeight: encodeURIComponent(meta.height) || '',
                videoWidth: encodeURIComponent(meta.width) || '',
                playerHeight: encodeURIComponent(config.height),
                playerWidth: encodeURIComponent(config.width),
                duration: meta.duration || '',
                size: meta.filesize || '',
                startPosition: model.get('position'),
                service: this.getDuration() > 0 ? 'vod' : 'lss',
                time: getTime(true),
                sessionTime: sessionTime,
                env: getEnv()
            };

            send(args);
            playEventTriggered = true;

            // 开始播放之后，每隔一分钟发一次请求统计，用于统计在线人数
            if (!onlineCountInterval) {
                onlineCountInterval = setInterval(function () {
                    args = {
                        action: '/user/web/count',
                        session: sessionTime,
                        url: model.get('file') || model.getCurrentItem().file
                    };
                    send(args);
                }, 60 * 1000);
                args = {
                    action: '/user/web/count',
                    session: sessionTime,
                    url: model.get('file') || model.getCurrentItem().file
                };
                send(args);
            }
        });

        _api.on('seek', function (e) {
            // console.log('onSeek');
            // console.log(e);

            playInterval = playInterval + (e.position - startPosition);
            // console.log('playInterval: ' + playInterval);
            startPosition = e.offset;
            // console.log('startPosition: ' + startPosition);

            args = {
                action: '/user/web/seek',
                videoUrl: model.get('file') || model.getCurrentItem().file,
                from: e.position,
                to: e.offset,
                time: getTime(true),
                sessionTime: sessionTime,
                env: getEnv()
            };
            send(args);
        });

        _api.on('pause', function () {
            // console.log('onPause');
            // console.log(e);

            playInterval = playInterval + (model.get('position') - startPosition);
            // console.log('playInterval: ' + playInterval);

            args = {
                action: '/user/web/pause',
                videoUrl: model.get('file') || model.getCurrentItem().file,
                time: getTime(true),
                sessionTime: sessionTime,
                env: getEnv()
            };
            send(args);
        });

        _api.on('idle', function (e) {
            if (e.reason === 'complete') {
                // console.log('onStop');
                // console.log(e);

                // 结束播放时，model.get('position') 已经是 0
                playInterval = playInterval + (model.get('duration') - startPosition);

                // console.log('playInterval: ' + playInterval);

                args = {
                    action: '/user/web/end',
                    videoUrl: model.get('file') || model.getCurrentItem().file,
                    playInterval: playInterval,
                    time: getTime(true),
                    sessionTime: sessionTime,
                    env: getEnv()
                };
                send(args);
            }
        });

        _api.on('stop', function () {
            // console.log('onStop');
            // console.log(e);
            playerStoped = true;
            clearInterval(waitMediaPlayInterval);
            waitMediaPlayInterval = null;
            clearInterval(onlineCountInterval);
            onlineCountInterval = null;

            if (!meta.duration) {
                return;
            }

            playInterval = playInterval + (model.get('position') - startPosition);
            // console.log('playInterval: ' + playInterval);

            args = {
                action: '/user/web/end',
                videoUrl: model.get('file') || model.getCurrentItem().file,
                playInterval: playInterval,
                time: getTime(true),
                sessionTime: sessionTime,
                env: getEnv()
            };
            send(args);
        });

        _api.on('error', function (e) {
            // console.log('onError');
            // console.log(e);

            clearInterval(waitMediaPlayInterval);

            args = {
                action: '/core/web/error',
                videoUrl: model.get('file') || model.getCurrentItem().file,
                error: e.code,
                errorInfo: e.message,
                time: getTime(true),
                sessionTime: sessionTime,
                env: getEnv()
            };
            send(args);
        });

        _api.on('setupError', function (e) {
            // console.log('onSetupError');
            // console.log(e);

            args = {
                action: '/core/web/error',
                videoUrl: model.get('file') || model.getCurrentItem().file,
                error: e.code,
                errorInfo: e.message,
                time: getTime(true),
                sessionTime: sessionTime,
                env: getEnv()
            };
            send(args);
        });

        var liveStartTimestamp;
        var liveStopTimestamp;

        _api.on('alive', function () {
            liveStartTimestamp = new Date().getTime();
        });

        _api.on('liveStop', function () {
            liveStopTimestamp = new Date().getTime();

            args = {
                action: '/user/web/end',
                videoUrl: model.get('file') || model.getCurrentItem().file,
                playInterval: (liveStopTimestamp - liveStartTimestamp) / 1000,
                time: getTime(true),
                sessionTime: sessionTime,
                env: getEnv()
            };
            send(args);
        });

        // 统计卡顿
        var isFirstBufferFull = true;
        var liveStart = false;
        var bufferStart;
        var bufferTime = 0;
        var bufferCount = 0;
        _api.on('alive', function () {
            // console.log('on alive');
            liveStart = true;

            if (isFirstBufferFull) {
                isFirstBufferFull = false;

                return;
            }

            if (!bufferStart) {
                return;
            }

            bufferTime = new Date().getTime() - bufferStart;
            bufferCount++;

            args = {
                action: '/user/web/buffer',
                session: sessionTime,
                url: model.get('file') || model.getCurrentItem().file,
                bt: bufferTime,
                bc: bufferCount,
                env: getEnv()
            };
            send(args);

            bufferStart = null;
        });

        _api.on('noLiveStream', function () {

            if (!liveStart) {
                return;
            }

            // hls 直播，noLiveStream和alive事件会重复触发
            if (bufferStart) {
                return;
            }

            bufferStart = new Date().getTime();
        });
    };

    return Log;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/plugins/log.js
 ** module id = 209
 ** module chunks = 0
 **/